import { useMemo, useRef, useState } from 'react'
import { ImageOverlay, MapContainer, Marker, useMapEvents } from 'react-leaflet'
import { CRS, LatLngTuple } from 'leaflet'
import { smallNumberIcon } from 'pages/building/floor/area/CustomMarker'
import { useRecoilState, useRecoilValue } from 'recoil'
import { floorDetailState, listPointState } from 'store/buildingStore'
import currentViewerState from 'store/viewerStore'

import useViewBuildingDetail from '../hooks/useViewBuildingDetail'

type Props = {
  refetchFloor: any
}

export default function ViewerFloorMap({ refetchFloor }: Props) {
  const mapContainerRef = useRef<any>(null)

  const [imgBounds, setImgBounds] = useState<LatLngTuple>([0, 0])

  const [currentViewer, setCurrentViewer] = useRecoilState(currentViewerState)
  const points = useRecoilValue(listPointState)
  const floorDetail = useRecoilValue(floorDetailState)

  const imagePath = useMemo(
    () => floorDetail?.mapFile?.s3Path,
    [floorDetail?.mapFile?.s3Path]
  )

  const { mapOnReady } = useViewBuildingDetail({
    imagePath,
    refetchFloor
  })

  function MapEventHandler() {
    useMapEvents({
      click() {
        setCurrentViewer((prev) => ({ ...prev, isOpenMiniMap: true }))
      }
    })
    return null
  }

  if (!imagePath) return null

  return (
    <div className="p-[10px] h-44">
      <MapContainer
        ref={mapContainerRef}
        center={[-99999, -99999]}
        zoom={0}
        zoomSnap={0.1}
        zoomDelta={0.5}
        className="area-map-container theme-bg-third"
        crs={CRS.Simple}
        zoomControl={false}
        attributionControl={false}
        preferCanvas
        whenReady={() => mapOnReady(mapContainerRef, setImgBounds)}
      >
        {/* handle map event */}
        <MapEventHandler />

        {points?.map((point) => (
          <Marker
            key={`marker ${point.id}`}
            draggable={false}
            zIndexOffset={
              point.id === currentViewer.selectedPoint ? 450 : 400 + point.order
            }
            // leaflet position is latlng with y=lat x=lng
            position={[point.y, point.x]}
            icon={smallNumberIcon(point, currentViewer.selectedPoint)}
          />
        ))}

        <ImageOverlay url={imagePath} bounds={[[0, 0], imgBounds]} />
      </MapContainer>
    </div>
  )
}
